import { Dialog } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import questionImage from 'assets/images/question.svg';

import { Button } from 'components/buttons';
import { Panel } from 'components/containers';
import IconCross from 'components/icons/cross';
import { Body, BoldMessage, Content, Delimeter, Image, Message, ModalControls, TitleMessage } from 'components/modal/styles';

import { Refunds } from 'types/pwcOrder';

import { formatNumberI18n } from 'utils/i18n';

import { LABELS } from '../../../../keys';
import { ModalRoot, StyledButtons } from './styles';

interface CancelRefundModalProps {
  isOpen: boolean;
  onClose: () => void;
  cancel: () => void;
  isCanceling: boolean;
  refund: Refunds | undefined;
}

export const CancelRefundModal = ({ isOpen, onClose, cancel, refund, isCanceling }: CancelRefundModalProps) => {
  const { t, i18n } = useTranslation();

  const closeModal = () => {
    onClose();
  };

  const formattedAmount = formatNumberI18n(i18n.language)(refund?.fiatAmount);

  return (
    <Dialog scroll="body" open={isOpen} onClose={closeModal}>
      <ModalRoot>
        <Panel
          label={t(LABELS.SECTIONS.CANCEL_REFUND.MODAL_TITLE)}
          controls={
            <ModalControls>
              <Button flat onClick={closeModal}>
                <IconCross />
              </Button>
            </ModalControls>
          }
        >
          <Body>
            <Content>
              <Image src={questionImage} />
              <TitleMessage>{t(LABELS.SECTIONS.CANCEL_REFUND.TITLE)}</TitleMessage>
              <Message>
                <Trans
                  i18nkey={LABELS.SECTIONS.CANCEL_REFUND.MESSAGE[1]}
                  defaults={LABELS.SECTIONS.CANCEL_REFUND.MESSAGE[1]}
                  values={{
                    amount: formattedAmount,
                    code: refund?.fiatCurrencyCode?.toUpperCase(),
                  }}
                  components={[<BoldMessage />]}
                />
              </Message>
            </Content>
            <Delimeter />
            <StyledButtons>
              <Button secondary onClick={closeModal}>
                {t(LABELS.SECTIONS.CANCEL_REFUND.CANCEL)}
              </Button>
              <Button disabled={isCanceling} onClick={cancel}>
                {t(LABELS.SECTIONS.CANCEL_REFUND.CONFIRM)}
              </Button>
            </StyledButtons>
          </Body>
        </Panel>
      </ModalRoot>
    </Dialog>
  );
};
